import { render, staticRenderFns } from "./PaymentCard.vue?vue&type=template&id=1be34d52&"
import script from "./PaymentCard.vue?vue&type=script&lang=js&"
export * from "./PaymentCard.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCard.vue?vue&type=style&index=0&id=1be34d52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports